/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { ThunkDispatch, ReduxState } from '@/types/redux'
import { resendEmailVerificationLinkRequest } from '@/apps/userconsole/reducers/registry'
import { getTheme } from '@/reducers/theme'
import { getLoginRequest } from '@/reducers/asyncRequests/registry'

import Login from '../../../../components/Login'
import { loginAndRedirect } from '../../actions/auth'
import { resendEmailVerificationLink } from '../../actions/account'

import type { ConsumerProps as LoginConsumerProps } from '../../../../components/Login/types'

type StateProps = Pick<
  LoginConsumerProps,
  'authMethods' | 'loginRequest' | 'theme' | 'resendEmailVerificationLinkRequest'
>
type DispatchProps = Pick<LoginConsumerProps, 'loginAndRedirect' | 'resendEmailVerificationLink'>

const mapStateToProps = (state: ReduxState): StateProps => ({
  authMethods: { password: true, saml: false, openid: false, sso_methods: [] },
  loginRequest: getLoginRequest(state),
  theme: getTheme(state),
  resendEmailVerificationLinkRequest: resendEmailVerificationLinkRequest(state),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  // @ts-ignore: To be resolved with distinct login types per environment
  loginAndRedirect: (params) => dispatch(loginAndRedirect(params)),
  resendEmailVerificationLink: (params) => dispatch(resendEmailVerificationLink(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
